import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = (typeof process !== 'undefined' && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  ? loadStripe("pk_test_r1qd5NgKnpKa1MV4DHQat0si")
  : loadStripe("pk_live_UVjMmhBJKgA7luGkcU1C8qMR");

const app = (
  <Elements stripe={stripePromise}>
    <App />
  </Elements>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
